export class Viewer {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonAccount",
            "baseName": "eonAccount",
            "type": "EonAccount",
            "format": ""
        },
        {
            "name": "selectedRole",
            "baseName": "selectedRole",
            "type": "Role",
            "format": ""
        },
        {
            "name": "roleToProjectsMappings",
            "baseName": "roleToProjectsMappings",
            "type": "{ [key: string]: IDs; }",
            "format": ""
        },
        {
            "name": "samlIdentityProvider",
            "baseName": "samlIdentityProvider",
            "type": "SamlIdentityProvider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Viewer.attributeTypeMap;
    }
    constructor() {
    }
}
